// extracted by mini-css-extract-plugin
module.exports = {"root":"ScrollContainer_root__1YdXX"};